import { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ChatbotWidget from './components/ChatbotWidget';
import Footer from './components/Footer';
import Header from './components/Header';
import InquiryModal from './components/InquiryModal';
import AdminPage from './pages/AdminPage';
import ConsentPage from './pages/ConsentPage';
import LandingPage from './pages/LandingPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import './App.css';

function SiteLayout() {
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const openInquiry = () => setInquiryOpen(true);
  const closeInquiry = () => setInquiryOpen(false);

  return (
    <div className="app-shell">
      <Header onInquiry={openInquiry} />
      <Routes>
        <Route path="/" element={<LandingPage onInquiry={openInquiry} />} />
        <Route path="/consent" element={<ConsentPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
      <InquiryModal open={inquiryOpen} onClose={closeInquiry} />
      <ChatbotWidget onInquiry={openInquiry} />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/*" element={<SiteLayout />} />
    </Routes>
  );
}

export default App;
